import React from 'react';
import Channel from './Container/Channel'

export default [
    {
        path: '/channel',
        exact: true,
        component: () => <Channel />
    }
];